import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import moment from "moment";

import { getGSTMonthWise } from "../../actions";
import { Loader } from "../common";
import { convertToCurrencyFormat } from "../../helpers/Utils";

class GST extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedMonth: moment().format('YYYY-MM'),
      isClicked: true,
    };
  }

  componentDidMount(){
     this.props.getGSTMonthWise(this.state.selectedMonth);
  }

  renderFilters() {
    const { selectedMonth } = this.state;
    return (
      <>
        <div
          style={{
            margin: 15,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <label
            style={{ color: "grey", fontWeight: 400, marginRight: 10 }}
            for="start"
          >
            Select month:
          </label>
          <input
            type="month"
            id="start"
            name="start"
            placeholder="Select Month"
            min="2021-11"
            value={selectedMonth}
            onChange={(event) =>
              this.setState({ selectedMonth: event.target.value })
            }
          ></input>
          <div
            style={{ width: 75, marginLeft: 10 }}
            className="Button Primary-Button"
            onClick={() => {
              this.props.getGSTMonthWise(selectedMonth);
              this.setState({ isClicked: true });
            }}
          >
            Submit
          </div>
        </div>
      </>
    );
  }

  renderTable(feeDetails) {
    const gstDetails = JSON.parse(feeDetails);
    const totalAmount = gstDetails.reduce(
      (acc, gstDetail) => acc + gstDetail.sum,
      0
    );
    const totalGST = gstDetails
      .reduce(
        (acc, gstDetail) => acc + (gstDetail.tax / 100) * gstDetail.sum,
        0
      )
      .toFixed(2);
    return (
      <table className="table-bordered">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Fee Name</th>
            <th style={{ textAlign: "right" }}>Fee Amount</th>
            <th style={{ textAlign: "right" }}>Tax (%)</th>
            <th style={{ textAlign: "right" }}>Collected Amount</th>
            <th style={{ textAlign: "right" }}>GST</th>
          </tr>
        </thead>
        <tbody>
          {gstDetails.map((gstDetail, index) => {
            const gst = ((gstDetail.tax / 100) * gstDetail.sum).toFixed(2);
            return (
              <tr style={{ color: "#343737" }}>
                <td>{index + 1}</td>
                <td>{gstDetail.fee_name}</td>
                <td style={{ textAlign: "right" }}>
                  {convertToCurrencyFormat(gstDetail.fee_amount)}
                </td>
                <td style={{ textAlign: "right" }}>{gstDetail.tax}</td>
                <td style={{ textAlign: "right" }}>
                  {convertToCurrencyFormat(gstDetail.sum)}
                </td>
                <td style={{ textAlign: "right" }}>
                  {convertToCurrencyFormat(gst)}
                </td>
              </tr>
            );
          })}
          <tr style={{ color: "#343737",fontWeight:'bold' }}>
            <td></td>
            <td></td>
            <td></td>
            <td style={{ fontWeight: 600, fontSize: 18, textAlign: "right" }}>
              Total:
            </td>
            <td style={{ textAlign: "right" }}>
              {convertToCurrencyFormat(totalAmount)}
            </td>
            <td style={{ textAlign: "right" }}>
              {convertToCurrencyFormat(totalGST)}
            </td>
          </tr>
        </tbody>
      </table>
    );
  }

  renderGSTDetails() {
    if (
      this.props.gstDetails.length === 0 &&
      this.state.isClicked &&
      this.state.selectedMonth
    ) {
      return (
        <div
          style={{
            fontWeight: 600,
            textAlign: "center",
            fontSize: 22,
            color: "grey",
            marginTop: "30%",
          }}
        >
          No Payments done for this month
        </div>
      );
    }
    if (!this.state.selectedMonth) {
      return (
        <div
          style={{
            fontWeight: 600,
            textAlign: "center",
            fontSize: 22,
            color: "grey",
            marginTop: "30%",
          }}
        >
          Please select month to get GST details of that month
        </div>
      );
    }
    return (
      <div style={{ padding: 50 }}>
        {this.props.gstDetails.map((feeAccount) => {
          return (
            <div style={{ marginBottom: 30 }}>
              <div style={{ fontWeight: 600, marginBottom: 20, fontSize: 20 }}>
                {feeAccount.name}
              </div>
              {this.renderTable(feeAccount.fee_details)}
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    if (this.props.isLoading) {
      return <Loader />;
    }
    return (
      <div>
        {this.renderFilters()}
        {this.renderGSTDetails()}
      </div>
    );
  }
}

GST.propTypes = {
  gstDetails: PropTypes.array,
};
GST.defaultProps = {
  gstDetails: [],
  isLoading: false,
};

const mapStateToProps = ({ home }) => ({
  isLoading: home.isLoading,
  gstDetails: home.gstDetails,
});

export default withRouter(connect(mapStateToProps, { getGSTMonthWise })(GST));
